import { apiMipe } from '@/core/api/';

export const validateIsActiveDayOfWeek = async (payload) => {
  return await apiMipe.post(
    'api/confrelatedserviceacademicweek/validateisactivedayofweek',
    payload
  );
};
